import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { AuthProvider } from "./contexts/AuthContext";
import { ThemeProvider } from "./contexts/ThemeContext";
import { LanguageProvider } from "./contexts/LanguageContext";
import axios from "axios";
import "./styles/index.scss";
import AppBoot from "./AppBoot";

import { HelmetProvider } from "react-helmet-async";

import { ToastProvider } from "./components/Alerts/Toast";

axios.defaults.baseURL = process.env.REACT_APP_API_BASE || "http://localhost:5000";

/* === viewport height fix for mobile Safari / iOS === */
function setAppViewportHeight() {
  const vh = window.innerHeight * 0.01;
  document.documentElement.style.setProperty("--app-vh", `${vh}px`);
}

setAppViewportHeight();
window.addEventListener("resize", setAppViewportHeight);
window.addEventListener("orientationchange", setAppViewportHeight);

if (window.visualViewport) {
  window.visualViewport.addEventListener("resize", setAppViewportHeight);
  window.visualViewport.addEventListener("scroll", setAppViewportHeight);
}
/* === end viewport fix === */

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <HelmetProvider>
      <BrowserRouter>
        <AuthProvider>
          <ThemeProvider>
            <LanguageProvider>
              <ToastProvider>
                <AppBoot>
                  <App />
                </AppBoot>
              </ToastProvider>
            </LanguageProvider>
          </ThemeProvider>
        </AuthProvider>
      </BrowserRouter>
    </HelmetProvider>
  </React.StrictMode>
);

reportWebVitals();